import React, { useState } from "react";
import Table from "../common/table";
import numeral from "numeral";
// import DateFormat from "../common/dateFormat";
import Pagination from "../common/pagination";
import { paginate } from "../../utils/paginate";
// import { partsToTextArea } from "./../../utils/itemUtils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from "lodash";

const GenMaterialUsageTable = (props) => {
  const {
    title,
    items,
    // onHeaderClick,
    // headerToolTip,
    onCreate,
    onDelete,
    // columns,
    sorting = { path: "title", order: "asc" },
    // controls = null,
  } = props;

  const columns = [
    {
      path: "ref.label",
      className: "w-25",
      label: "Production",
    },
    {
      path: "ref.lineId",
      className: "text-center",
      label: "Line",
    },
    {
      path: "item.label",
      className: "w-25 text-center",
      label: "Production Item",
    },
    {
      path: "qty",
      className: "text-center",
      label: "Qty",
    },
    {
      path: "inventory.label",
      className: "w-25 text-center",
      label: "Material",
    },
    {
      path: "partQty",
      className: "text-center",
      label: "Material Qty",
      content: (txn) => numeral(txn.partQty).format(0, 0.0),
    },
    // {
    //   path: "parts",
    //   label: "Generate",
    //   className: "w-25",
    //   content: (txn) => (
    //     <div style={{ whiteSpace: "pre-wrap" }}>
    //       {txn.parts && partsToTextArea(txn.parts)}
    //     </div>
    //   ),
    // },
    {
      key: "controls",
      className: "text-right",
      content: (txn) => (
        <div className="d-flex text-right">
          <div>
            <button
              onClick={() => onCreate(txn)}
              className="btn btn-outline-primary btn-sm"
              data-toggle="tooltip"
              data-placement="top"
              title="Create production receipt"
              disabled={txn.isProd ? true : false}
            >
              <FontAwesomeIcon icon="plus" />
            </button>
          </div>
          <div>
            <button
              onClick={() => onDelete(txn)}
              className="btn btn-outline-danger btn-sm ml-1"
              data-toggle="tooltip"
              data-placement="top"
              title="Remove from the update list"
            >
              <FontAwesomeIcon icon="trash" />
            </button>
          </div>
        </div>
      ),
    },
  ];

  const [sortColumn, setSortColumn] = useState(sorting);
  const [currentPage, setPage] = useState(1);
  const pageSize = 30;

  const handleSort = (sortColumn) => {
    setSortColumn(sortColumn);
  };

  const totals = { items: items.length };
  //   totals.qty = items.reduce((sum, i) => {
  //     return sum + i.data.qty;
  //   }, 0);

  const sorted = _.orderBy(items, [sortColumn.path], [sortColumn.order]);

  const data = paginate(sorted, currentPage, pageSize);

  return (
    <div className="my-2">
      <div className="d-flex justify-content-between pt-2">
        <h5
          className="text-uppercase clickable"
          data-toggle="tooltip"
          data-placement="top"
          // title={headerToolTip}
          // onClick={onHeaderClick}
        >{`${title} (${totals.items})`}</h5>
        {/* <div>{controls}</div> */}
      </div>
      <div className="border rounded bg-white p-3 shadow-sm">
        {totals.items < 1 ? (
          "No transactions"
        ) : (
          <Table
            columns={columns}
            data={data}
            sortColumn={sortColumn}
            onSort={handleSort}
            onCreate={onCreate}
            onDelete={onDelete}
            totals={totals}
          />
        )}
        <Pagination
          itemsCount={totals.items}
          pageSize={pageSize}
          currentPage={currentPage}
          onPageChange={(pageNumber) => setPage(pageNumber)}
        />
      </div>
    </div>
  );
};

export default GenMaterialUsageTable;
